export default {
    title: 'พนักงานทั้งหมด',
    weekly: 'รายสัปดาห์',
    mon: 'จ.',
    tue: 'อ.',
    wed: 'พ.',
    thu: 'พฤ.',
    fri: 'ศ.',
    sat: 'ส.',
    sun: 'อา.',
    present: 'ตรงเวลา',
    late: 'สาย'
}
